"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsCreateAnalyticsEventRequestTargetEnum = exports.AnalyticsCreateAnalyticsEventRequestActionEnum = exports.AnalyticsCreateAnalyticsEventRequestPlacementEnum = exports.AnalyticsCreateAnalyticsEventRequestNameEnum = void 0;
exports.AnalyticsCreateAnalyticsEventRequestNameEnum = {
    Referral: 'referral',
    Recommendation: 'recommendation',
    Resource: 'resource',
    Activity: 'activity',
};
exports.AnalyticsCreateAnalyticsEventRequestPlacementEnum = {
    Home: 'home',
    CarePlan: 'care_plan',
    MentalHealthSurveyResults: 'mental_health_survey_results',
    Discover: 'discover',
    Resources: 'resources',
    ProgramDetails: 'program_details',
    ActivitySheet: 'activity_sheet',
};
exports.AnalyticsCreateAnalyticsEventRequestActionEnum = {
    Click: 'click',
    View: 'view',
};
exports.AnalyticsCreateAnalyticsEventRequestTargetEnum = {
    Url: 'url',
    Phone: 'phone',
    Text: 'text',
    Sms: 'sms',
    Screen: 'screen',
};
//# sourceMappingURL=analytics-create-analytics-event-request.js.map